/** 
 * Translated from enum com.dataiku.dip.eda.compute.stats.PValueAdjustmentMethod
 * Via: com.dataiku.dip.eda.compute.computations.univariate.PairwiseMoodTest
 */
export enum PValueAdjustmentMethod {
    FDR_BH = "FDR_BH",
    BONFERRONI = "BONFERRONI",
    NONE = "NONE",
    HOLM_BONFERRONI = "HOLM_BONFERRONI",
}